import { useState } from "react";

export function FAQ({ className, children }) {
  return <section className={className}>{children}</section>;
}

export function FAQList({ children }) {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-xl-8">{children}</div>
      </div>
    </div>
  );
}

export function FAQItem({ question, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="data-group">
      <div className="row">
        <div
          className={`data-expands ${isOpen ? "row-active" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <h2 className="color-purple">{question}</h2>
          <span className={`row-toggle ${isOpen ? "row-toggle-twist" : ""}`}>
            <span className="horizontal"></span>
            <span className={`vertical ${isOpen ? "hidden" : ""}`}></span>
          </span>
        </div>
        <div className={`expandable ${isOpen ? "row-open" : ""}`}>
          {children}
        </div>
      </div>
      <div className="rule bg-red-fade"></div>
    </div>
  );
}
